module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ftit1"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _vm._v("T"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("HIRTEEN")]), _vm._v(" M"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("ONTHS IN")]), _vm._v(" D"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("IXIE, OR,")]), _vm._v(" T"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("HE")]), _vm._v(" A"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("DVENTURES OF A")]), _vm._v(" F"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("EDERAL")]), _vm._v(" P"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("RISONER IN")]), _vm._v(" T"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("EXAS")])]), _vm._v(" "), _c('p', {
    staticClass: "chaut"
  }, [_vm._v("by W. F. Oscar Federhen")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("I"), _c('span', {
    staticClass: "chsmallb"
  }, [_vm._v("T WAS")])]), _vm._v(" a clear, mild moonlight night. Not an atom disturbed the sacred rest of mother Earth, when four of us were lying around a half extinguished camp-fire, thinking and talking over the past, of the battles we went through, of the hair-breadth escapes some of us had had; in short, our minds wandered back to the days of excitement and danger, when Rebellion had gained the zenith of its artificial glory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three of us had told our story. Only our friend, Oscar Federhen, remained silent, and the only sign of his approbation of some dangerous, but well performed duty, was a slight nod of the head, and a double cloud of smoke, emerging from out of his wooden pipe, the soldier’s only reliable friend and companion. After much persuading and coaxing, we gained his consent to narrate his history to us. This gained, we replenished our pipes, and, after having lighted them, Oscar began."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent_6"
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wangyal Shawa")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "map_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fxxii-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "notet"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(" This Introduction purports to be composed by another narrator, but it is written in the same hand (i.e., Oscar’s) as the rest of the manuscript.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df09b4be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_Federhens_Introduction.vue
// module id = 93
// module chunks = 0